import React from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment } from '@material-ui/core';
import Icons from '../Icons';

function InputFilter({ handleFilterChange, inputType, placeholder, value, nameFocus, id, width }) {
  const autoFocus = nameFocus === id;
  return (
    <TextField
      type={inputType}
      key={id}
      value={value || ''}
      onChange={(event) => { handleFilterChange(event.target.value); }}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      InputProps={{
        startAdornment: <InputAdornment position="start"><Icons.Filter /></InputAdornment>,
        autoFocus,
        style:          {
          width,
        },
      }}
      style={{
        textTransform: 'capitalize',
      }}
    />
  );
}

InputFilter.propTypes = {
  handleFilterChange: PropTypes.func.isRequired,
  placeholder:        PropTypes.string,
  value:              PropTypes.string,
  id:                 PropTypes.string,
  nameFocus:          PropTypes.string,
  width:              PropTypes.string,
  inputType:          PropTypes.string,
};

InputFilter.defaultProps = {
  placeholder: '',
  value:       null,
  id:          null,
  nameFocus:   null,
  inputType:   'text',
  width:       '100px',

};

export default InputFilter;
